import { Params } from '@angular/router';
import { PassedInitialConfig } from 'angular-auth-oidc-client';
import { environment } from 'src/environments/environment';

// offline_access is what makes Auth0 return a refresh token.
const scope = 'openid profile offline_access email auth0-user-api-spa';

/** Forwarded from the entry URL to Auth0 `/authorize` for invitation and organization onboarding. */
export const AUTH_FORWARDED_QUERY_PARAMS = ['invitation', 'organization', 'organization_name'] as const;

export const pickForwardedAuthParams = (queryParams: Params): Record<string, string> => {
  const forwarded: Record<string, string> = {};
  for (const key of AUTH_FORWARDED_QUERY_PARAMS) {
    const value = queryParams[key];
    if (value) forwarded[key] = value;
  }
  return forwarded;
};

export const authConfig: PassedInitialConfig = {
  config: {
    authority: environment.auth0.authority,
    redirectUrl: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    clientId: environment.auth0.clientId,
    scope,
    responseType: 'code',
    silentRenew: true,
    useRefreshToken: true,
    // /userinfo is rate-limited, and a failure during renewal makes the library wipe the session.
    autoUserInfo: false,
    // Without it, syncUserSession() pushes the login-time userData back and overwrites an edited profile.
    renewUserInfoAfterTokenRenew: true,
    renewTimeBeforeTokenExpiresInSeconds: 30,
    maxIdTokenIatOffsetAllowedInSeconds: 300,
    logLevel: environment.auth0.logLevel,
    secureRoutes: [environment.apiUrl],
    customParamsAuthRequest: {
      audience: environment.auth0.audience,
    },
    customParamsRefreshTokenRequest: {
      scope,
      // Without it, the renewed token targets /userinfo and the API and websocket reject it.
      audience: environment.auth0.audience,
    },
  },
};
